import React, { useState, createContext, useContext } from 'react';
export interface ScheduleItem {
  id: string;
  activityType: string;
  subject: string;
  startTime: string;
  endTime: string;
  notes?: string;
  completed: boolean;
  isInstitutional?: boolean;
}
export type ScheduleData = Record<string, ScheduleItem[]>;
// Mock data for the entire week
export const MOCK_PROGRAM_DATA: ScheduleData = {
  Pazartesi: [{
    id: 'inst-1',
    activityType: 'study',
    subject: 'MATEMATİK',
    startTime: '09:00',
    endTime: '10:30',
    notes: 'Okul dersi - Matematik',
    completed: true,
    isInstitutional: true
  }, {
    id: 'personal-1',
    activityType: 'practice',
    subject: 'MATEMATİK',
    startTime: '14:00',
    endTime: '15:00',
    notes: 'Integral soruları çözümü',
    completed: false,
    isInstitutional: false
  }, {
    id: 'personal-2',
    activityType: 'video',
    subject: 'FEN BİLİMLERİ',
    startTime: '16:00',
    endTime: '17:00',
    notes: 'Fizik - Kuvvet ve Hareket',
    completed: true,
    isInstitutional: false
  }],
  Salı: [{
    id: 'inst-2',
    activityType: 'study',
    subject: 'TÜRKÇE',
    startTime: '10:45',
    endTime: '12:15',
    notes: 'Okul dersi - Türkçe',
    completed: true,
    isInstitutional: true
  }, {
    id: 'personal-3',
    activityType: 'homework',
    subject: 'TÜRKÇE',
    startTime: '18:00',
    endTime: '19:00',
    notes: 'Dil bilgisi ödevleri',
    completed: false,
    isInstitutional: false
  }],
  Çarşamba: [{
    id: 'inst-3',
    activityType: 'study',
    subject: 'FEN BİLİMLERİ',
    startTime: '13:00',
    endTime: '14:30',
    notes: 'Okul dersi - Fen Bilimleri',
    completed: true,
    isInstitutional: true
  }, {
    id: 'personal-4',
    activityType: 'practice',
    subject: 'FEN BİLİMLERİ',
    startTime: '15:30',
    endTime: '16:30',
    notes: 'Kimya problemleri',
    completed: true,
    isInstitutional: false
  }, {
    id: 'personal-5',
    activityType: 'exam',
    subject: 'MATEMATİK',
    startTime: '19:00',
    endTime: '20:00',
    notes: 'Deneme sınavı hazırlığı',
    completed: false,
    isInstitutional: false
  }],
  Perşembe: [{
    id: 'inst-4',
    activityType: 'study',
    subject: 'İNGİLİZCE',
    startTime: '11:00',
    endTime: '12:00',
    notes: 'Okul dersi - İngilizce',
    completed: false,
    isInstitutional: true
  }, {
    id: 'personal-6',
    activityType: 'video',
    subject: 'İNGİLİZCE',
    startTime: '17:00',
    endTime: '18:00',
    notes: 'Grammar video dersleri',
    completed: true,
    isInstitutional: false
  }, {
    id: 'personal-7',
    activityType: 'practice',
    subject: 'T.C. İNKILAP TARİHİ VE ATATÜRKÇÜLÜK',
    startTime: '20:00',
    endTime: '21:00',
    notes: 'Tarih soruları',
    completed: false,
    isInstitutional: false
  }],
  Cuma: [{
    id: 'inst-5',
    activityType: 'exam',
    subject: 'MATEMATİK',
    startTime: '15:00',
    endTime: '16:30',
    notes: 'Matematik sınavı',
    completed: false,
    isInstitutional: true
  }, {
    id: 'personal-8',
    activityType: 'study',
    subject: 'DİN KÜLTÜRÜ VE AHLÂK BİLGİSİ',
    startTime: '14:00',
    endTime: '15:00',
    notes: 'Konu tekrarı',
    completed: true,
    isInstitutional: false
  }, {
    id: 'personal-9',
    activityType: 'homework',
    subject: 'TÜRKÇE',
    startTime: '18:30',
    endTime: '19:30',
    notes: 'Kompozisyon yazma',
    completed: false,
    isInstitutional: false
  }, {
    id: 'personal-10',
    activityType: 'video',
    subject: 'MATEMATİK',
    startTime: '20:00',
    endTime: '21:00',
    notes: 'Geometri video dersleri',
    completed: false,
    isInstitutional: false
  }],
  Cumartesi: [{
    id: 'personal-11',
    activityType: 'exam',
    subject: 'TÜRKÇE',
    startTime: '10:00',
    endTime: '12:00',
    notes: 'Haftalık deneme sınavı',
    completed: true,
    isInstitutional: false
  }, {
    id: 'personal-12',
    activityType: 'practice',
    subject: 'MATEMATİK',
    startTime: '14:00',
    endTime: '16:00',
    notes: 'Haftanın zor soruları',
    completed: false,
    isInstitutional: false
  }],
  Pazar: [{
    id: 'personal-13',
    activityType: 'study',
    subject: 'FEN BİLİMLERİ',
    startTime: '11:00',
    endTime: '12:30',
    notes: 'Haftalık konu tekrarı',
    completed: false,
    isInstitutional: false
  }, {
    id: 'personal-14',
    activityType: 'video',
    subject: 'İNGİLİZCE',
    startTime: '15:00',
    endTime: '16:00',
    notes: 'Speaking practice videos',
    completed: false,
    isInstitutional: false
  }]
};
// Helper functions for schedule styling and display
export const getActivityIcon = (type: string) => {
  // This will be implemented in the component files
  return null;
};
export const getActivityLabel = (type: string) => {
  switch (type) {
    case 'study':
      return 'Konu Çalışma';
    case 'practice':
      return 'Soru Çözüm';
    case 'exam':
      return 'Deneme';
    case 'video':
      return 'Video İzleme';
    case 'homework':
      return 'Ödev Yapma';
    default:
      return 'Etkinlik';
  }
};
export const getSubjectGradient = (subject: string) => {
  const subjectUpper = subject.toUpperCase();
  if (subjectUpper.includes('TÜRKÇE')) return 'from-red-600 to-red-700';
  if (subjectUpper.includes('MATEMATİK')) return 'from-blue-600 to-blue-700';
  if (subjectUpper.includes('FEN')) return 'from-emerald-600 to-emerald-700';
  if (subjectUpper.includes('İNKILAP')) return 'from-amber-600 to-amber-700';
  if (subjectUpper.includes('İNGİLİZCE')) return 'from-purple-600 to-purple-700';
  if (subjectUpper.includes('DİN')) return 'from-indigo-600 to-indigo-700';
  return 'from-blue-600 to-indigo-600';
};
// Context for program data
const ProgramContext = createContext<{
  scheduleData: ScheduleData;
  setScheduleData: React.Dispatch<React.SetStateAction<ScheduleData>>;
} | null>(null);
export const ProgramProvider = ({
  children
}: {
  children: ReactNode;
}) => {
  const [scheduleData, setScheduleData] = useState<ScheduleData>(MOCK_PROGRAM_DATA);
  return <ProgramContext.Provider value={{
    scheduleData,
    setScheduleData
  }} data-id="element-1178">
      {children}
    </ProgramContext.Provider>;
};
export const useProgramData = () => {
  const context = useContext(ProgramContext);
  if (!context) {
    throw new Error('useProgramData must be used within a ProgramProvider');
  }
  return context;
};